import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface StatusOption {
  /** Canonical value sent back to the API, e.g. 'Active'. */
  value: string;
  label: string;
}

export interface StatusChangeResult {
  action: 'confirm' | 'cancel';
  status?: string;
}

@Component({
  selector: 'app-status-change-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './status-change-modal.component.html',
})
export class StatusChangeModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title = 'Cambiar estado';
  @Input() description?: string;
  @Input() options: StatusOption[] = [];
  /** Canonical value of the row's current status. */
  @Input() currentStatus = '';
  @Output() closed = new EventEmitter<StatusChangeResult>();

  selected = '';

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    // A status outside the offered set (a pending employee, say) must not silently
    // preselect one of them; leave the placeholder showing instead.
    this.selected = this.options.some((o) => o.value === this.currentStatus)
      ? this.currentStatus
      : '';
  }

  ngAfterViewInit(): void {
    // Escapes any stacking or overflow context the table puts around it
    document.body.appendChild(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    const element = this.elementRef.nativeElement;
    if (element?.parentNode === document.body) {
      document.body.removeChild(element);
    }
  }

  get unchanged(): boolean {
    return !this.selected || this.selected === this.currentStatus;
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.onCancel();
    }
  }

  onCancel(): void {
    this.closed.emit({ action: 'cancel' });
  }

  onConfirm(): void {
    if (this.unchanged) return;
    this.closed.emit({ action: 'confirm', status: this.selected });
  }
}
